import React from 'react'

const CheckPoint = () => (
  <svg fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.15 9.59002C7.95115 9.58984 7.76052 9.51071 7.62 9.37002L6.25 8.00002C6.10705 7.86073 6.02643 7.66961 6.02643 7.47002C6.02643 7.27043 6.10705 7.07931 6.25 6.94002C6.54282 6.64757 7.01718 6.64757 7.31 6.94002L8.15 7.78002L12.63 3.29002C12.9228 2.99757 13.3972 2.99757 13.69 3.29002C13.8329 3.42931 13.9136 3.62043 13.9136 3.82002C13.9136 4.01961 13.8329 4.21073 13.69 4.35002L8.69 9.35002C8.55043 9.50055 8.35526 9.58729 8.15 9.59002Z"
      fill="#D14532"
    />
    <path
      d="M8 14C4.68629 14 2 11.3138 2 8.00004C2 4.68634 4.68629 2.00004 8 2.00004C8.85619 1.99671 9.70271 2.18103 10.48 2.54004C10.8595 2.7127 11.0291 3.15891 10.86 3.54004C10.6798 3.91155 10.2386 4.07478 9.86 3.91004C9.27649 3.64297 8.64172 3.50646 8 3.51004C6.12198 3.51418 4.44588 4.68923 3.80168 6.45331C3.15748 8.2174 3.68195 10.196 5.11536 11.4094C6.54877 12.6228 8.58685 12.8134 10.2203 11.8867C11.8538 10.9601 12.736 9.11297 12.43 7.26004C12.3953 7.06226 12.4414 6.85884 12.558 6.69532C12.6745 6.5318 12.8517 6.42184 13.05 6.39004C13.4608 6.32365 13.8487 6.60003 13.92 7.01004C13.9719 7.33752 13.9986 7.66849 14 8.00004C14 11.3138 11.3137 14 8 14Z"
      fill="#D14532"
    />
  </svg>
)

export default CheckPoint
